import React, {PureComponent} from 'react';
import PropTypes from "prop-types";
import AsyncTable from './tables/AsyncTable';
import AsyncForm from './form/asyncForm';

class Demo extends PureComponent {
  constructor (props) {
    super();
    this.init();
    this.props = props;
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  init () {
  }

  render () {
    return <div>
      <AsyncForm tableKey={'008'} />
      <AsyncTable tableKey={'008'}></AsyncTable>
    </div>
  }
}

export default Demo;

Demo.propTypes = {
  addTab: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/AntD/pages/example/asyncGenerateTable/demo.js